import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BGA, CONNECTOR } from '@/constants/componentType';
import { filterTestPoint } from '../../../services/Andes_v2/channel';
import { updateMultiModelStatus, updateChannelContent } from '../store/channel/action';
import { PACKAGE } from '@/constants/designType';
import ChannelBuilder from './ChannelBuilder'
import { Divider } from 'antd';
import { SERDES_TYPES } from '../../../services/PCBHelper';
import "./index.css";

class MultiModelContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newComponents: [],
      otherComponents: [],
    }
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
    this.updateComponents();
  }

  componentDidUpdate(prevProps) {
    const { multiModelUpdateStatus, verificationId, channelLoading } = this.props;
    if ((verificationId !== prevProps.verificationId) || multiModelUpdateStatus || (channelLoading !== prevProps.channelLoading && !channelLoading)) {
      this.updateComponents();
      multiModelUpdateStatus && this.props._updateMultiModelStatus(false)
    }
  }

  updateComponents = () => {
    const { components, design, verificationId, comp_merges } = this.props;
    let _newComponents = [];
    const filterComponents = filterTestPoint(components, comp_merges);
    if (filterComponents && filterComponents.length && design) {
      if (design.type === PACKAGE) {
        //When the opened page is a package channel, item.type===BGA
        _newComponents = filterComponents.filter(item => item.type === BGA);
      } else {
        // When the open page is channel, the package is connected in the IC
        //The Component of the Connector is connected to subsequent models
        _newComponents = filterComponents.filter(item => item.type === CONNECTOR)
      }
    }

    // If there is no Connector/BGA component, a Channel Builder will be displayed.
    if (!_newComponents.length) {
      const ICComps = filterComponents.filter(item => SERDES_TYPES.includes(item.type));
      if (ICComps.length === 1) {
        _newComponents = ICComps;
      } else if (ICComps.length > 1) {
        const maxPinsObj = ICComps.reduce((prev, curr) => {
          return prev.pins.length > curr.pins.length ? prev : curr;
        });
        _newComponents = [maxPinsObj]
      }
    }


    const newCompNames = _newComponents.map(item => item.name);
    this.setState({
      newComponents: _newComponents.map(item => ({ ...item, verificationId })),
      otherComponents: filterComponents.filter(item => !newCompNames.includes(item.name) && SERDES_TYPES.includes(item.type)),
    }, () => {
      this.updateContent()
    })
  }

  updateContent = () => {
    const { newComponents } = this.state;
    newComponents.forEach((item, index) => {
      const key = `multiModel${index + 1}Ref`;
      this[key] && this[key].updateContent();
    });
  }

  compNameTitleRender = (compName) => {
    const { newComponents } = this.state;
    if (newComponents.length < 2) { return null }
    return <div className='andes-v2-channel-builder-comp-name-title'>
      <div className='title-box'>{compName} Channel Builder</div>
      <Divider className='divider-line' />
    </div>
  }

  updateChannelComponents = (newComponents, isUpdate) => {
    this.props._updateChannelComponents(newComponents);
    if (isUpdate) {
      this.props._updateMultiModelStatus(true);
    }
  }

  getNewCompName = () => {
    const { newComponents } = this.state;
    return newComponents.map(item => item.name);
  }

  render() {
    const { signals, serdesType, multiModelUpdateStatus, components, design = {}, libraryStatus, needChangeComp } = this.props;
    const { newComponents, otherComponents } = this.state;
    if (!newComponents || !newComponents.length) { return null }
    return <div className='space-10'>
      <div className="aurora-setup-border" id="channel-builder-multi-content-setup-dialog">
        <span className='out-title-color font-bold'>Channel Builder</span>
        {newComponents.map((comp, index) => {
          const { name } = comp;
          return <div
            key={index}
            className={`setup-package-model-content channel-builder-content ${needChangeComp === name ? "andes-v2-glow-border" : ""}`}
            id={`${name}-multi-content-setup-dialog`}
          >
            <ChannelBuilder
              ref={(ele) => this[`multiModel${index + 1}Ref`] = ele}
              currentComp={comp}
              otherComponents={otherComponents}
              components={components}
              signals={signals}
              serdesType={serdesType}
              designType={design.type}
              multiModelUpdateStatus={multiModelUpdateStatus}
              updateChannelComponents={this.updateChannelComponents}
              compNameTitleRender={this.compNameTitleRender}
              libraryStatus={libraryStatus}
            />
          </div>
        })}
      </div>
    </div>
  }
}

const mapState = (state) => {
  const {
    channel: {
      channelInfo: { content = {}, type, verificationId },
      multiModelUpdateStatus,
      channelLoading
    },
    library: { libraryStatus },
  } = state.AndesV2Reducer;
  const {
    components = [],
    signals = [],
    comp_merges = [],
    comp_copies = []
  } = content;

  return {
    components,
    signals,
    serdesType: type,
    verificationId,
    comp_merges,
    comp_copies,
    libraryStatus,
    multiModelUpdateStatus,
    channelLoading
  }
}

const mapDispatch = (dispatch) => ({
  _updateMultiModelStatus(status) {
    dispatch(updateMultiModelStatus(status))
  },
  _updateChannelComponents(components) {
    dispatch(updateChannelContent({ components }));
  }
})

export default connect(mapState, mapDispatch)(MultiModelContent);